<template>
    <v-card>
        <v-card-title>経緯表</v-card-title>
        <v-card-subtitle class="history__name d-flex pb-0">
            <span class="me-5">
                {{ customer.family_name }} {{ customer.given_name }} ({{ customer.family_name_kana }}
                {{ customer.given_name_kana }})
            </span>
            <div class="ms-5">
                <span class="">
                    契約終了日: {{ endDate }}
                </span><br />
                <span v-if="endDateShift" :style="{color: endDateShift.includes('無し') || endDateShift.includes('未実施') ? 'crimson' : ''}">
                    (シフト交渉最終日: {{ endDateShift }})
                </span>
            </div>
            <div class="ml-auto" v-if="customer.connect_federation || customer.ibj_federation">
                <table style="border: 1px solid #ccc; border-collapse: collapse;">
                    <tr>
                        <th :colspan="(customer.connect_federation && customer.ibj_federation) ? 2 : 1" style="border: 1px solid #ccc; padding: 4px 8px; text-align: center; background-color: #f5f5f5; font-size: 13px; white-space: nowrap; min-width: 80px;">連盟情報</th>
                    </tr>
                    <tr>
                        <th v-if="customer.connect_federation" style="border: 1px solid #ccc; padding: 4px 8px; width: 80px; text-align: center; background-color: #f5f5f5; white-space: nowrap; font-size: 12px;">コネクト</th>
                        <th v-if="customer.ibj_federation" style="border: 1px solid #ccc; padding: 4px 8px; width: 80px; text-align: center; background-color: #f5f5f5; white-space: nowrap; font-size: 12px;">IBJ</th>
                    </tr>
                </table>
            </div>
        </v-card-subtitle>
        <v-card-subtitle id="note">
            <b>＜引継メモ＞</b> <br />
            <b>会員様に関する注意点や特別な要望などの共有事項を記載してください。</b>
        </v-card-subtitle>
        <vue-editor id="customer-note" :editorToolbar="customToolbar" v-model="customerNote"
            @blur="onEditorBlur"></vue-editor>
        <v-container fluid>
            <v-row dense>
                <v-col>
                    <v-btn :to="`/customer/${$route.params.id}`">カルテ
                    </v-btn>
                    <v-btn :to="`/customer/history/${$route.params.id}`">経緯表
                    </v-btn>
                    <v-btn v-if="customer.gender != 2" :to="`/customer/matching/${$route.params.id}`">お相手選択
                    </v-btn>
                    <v-btn v-else :to="`/customer/matching_history/${$route.params.id}`">お相手履歴
                    </v-btn>
                    <v-btn @click="openSheet(customer.sheet_id)" v-if="customer.sheet_id">旧カルテを開く
                    </v-btn>
                    <v-btn :to="`/customer/file-manager/${$route.params.id}`">画像管理
                    </v-btn>
                    <v-btn :class="{ 'pink white--text': claimFiles.length }"
                        :to="`/customer/claim-manager/${$route.params.id}`">クレーム管理
                    </v-btn>
                </v-col>
                <v-col class="text-right">
                    <v-btn
                        v-if="customer.line_link"
                        :style="{ backgroundColor: '#06C755', color: 'white' }"
                        @click="openLineLink"
                        class="mx-2"
                    >
                        LINEへ移動
                    </v-btn>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="info" dark v-bind="attrs" v-on="on">
                                新規登録
                            </v-btn>
                        </template>
                        <v-list height="90vh" class="overflow-auto">
                            <v-list-item v-for="(item, index) in formItems" :key="index">
                                <v-list-item-title @click="callFormCreate(item)" style="cursor: pointer;">
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <!-- <v-btn class="info" @click="addDialog()">新規登録
                    </v-btn> -->
                </v-col>
            </v-row>
        </v-container>
        <v-data-table :headers="headers" :items="histories" :server-items-length="histories.length" :loading="loading"
            hide-default-footer dense class="table-history">
            <template v-slot:[`item`]="{ item }">
                <tr :class="rowClass(item)">
                    <td :class="computedTextAlign('target_date')">
                        {{ item.target_date }} {{ item.target_time }}
                    </td>
                    <td :class="computedTextAlign('kind')">
                        {{ getKindName(item) }}
                    </td>
                    <td :class="computedTextAlign('counselor_id')">
                        {{ showCounselorName(item.counselor_id) }}
                        {{ showCounselorName(item) }}
                    </td>
                    <td :class="computedTextAlign('status')">
                        {{ drawStatus(item) }}
                    </td>
                    <td :class="computedTextAlign('note') + ' history-note'">
                        <template v-if="item.type == CUSTOMER.TYPE_FORM.IN_HOUSE_MATCH">
                            <span class="mr-2">
                                {{
                                    customer.gender != CUSTOMER.GENDER.VAL.MALE
                                        ? (item.male_customer ? item.male_customer.family_name : '') + (item.male_customer ?
                                            item.male_customer.given_name : '')
                                        : (item.female_customer ? item.female_customer.family_name : '') + (item.female_customer
                                            ?
                                            item.female_customer.given_name : '')
                                }}
                            </span>
                        </template>
                        <template v-if="item.type == CUSTOMER.TYPE_FORM.INPUT_PARTNER_SELECTION">
                            <span v-for="(matching_history, key_matching) in item.matching_histories" class="mr-2"
                                :key="key_matching">
                                {{
                                    matching_history.member_connect
                                        ? (JSON.parse(matching_history.member_connect)).connect_name || 
                                          (customer.gender != CUSTOMER.GENDER.VAL.MALE
                                            ? (matching_history.customer_male ? matching_history.customer_male.family_name : '') +
                                            (matching_history.customer_male ? matching_history.customer_male.given_name : '')
                                            : (matching_history.customer_female ? matching_history.customer_female.family_name : '')
                                            +
                                            (matching_history.customer_female ? matching_history.customer_female.given_name : ''))
                                        : (customer.gender != CUSTOMER.GENDER.VAL.MALE
                                            ? (matching_history.customer_male ? matching_history.customer_male.family_name : '') +
                                            (matching_history.customer_male ? matching_history.customer_male.given_name : '')
                                            : (matching_history.customer_female ? matching_history.customer_female.family_name : '')
                                            +
                                            (matching_history.customer_female ? matching_history.customer_female.given_name : ''))
                                }}
                                {{
                                    CUSTOMER.INDIVIDUAL_RESULTS.getName(customer.gender != CUSTOMER.GENDER.VAL.MALE
                                        ? matching_history.female_result
                                        : matching_history.male_result)
                                }}
                            </span>
                        </template>
                        <template v-if="item.type == CUSTOMER.TYPE_FORM.CONNECT_ARRANGEMENT">
                            <span class="mr-2">
                                {{ (item.connect_name || '') + ' ' + (item.connect_area || '') }}
                            </span>
                        </template>
                        <template v-if="item.type == CUSTOMER.TYPE_FORM.DATE_INPUT">
                            <span class="mr-2">
                                {{
                                    customer.gender != CUSTOMER.GENDER.VAL.MALE
                                        ? (item.male_customer ? item.male_customer.family_name : '') + (item.male_customer ?
                                            item.male_customer.given_name : '')
                                        : (item.female_customer ? item.female_customer.family_name : '') + (item.female_customer
                                            ?
                                            item.female_customer.given_name : '')
                                }}
                            </span>
                        </template>
                        <div class="mr-2"
                            v-if="item.shift_negotiations !== null && item.shift_negotiations !== undefined">
                            シフト交渉: {{ CUSTOMER.STATUS_SHIFT_NEGOTIATIONS.getName(item.shift_negotiations) }}
                        </div>
                        {{ item.note }}
                    </td>
                    <td :class="computedTextAlign('buttons')">
                        <v-btn dark class="edit my-1" @click="updateDialog(item.id)">
                            変更
                        </v-btn>
                        <v-btn dark class="error mb-1" @click="deleteConfirm(item.id)" v-if="canDelete()">
                            削除
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog" persistent max-width="960px">
                <v-form>
                    <v-card>
                        <v-card-title>
                            <span class="headline" v-if="!isUpdate">経緯表追加</span>
                            <span class="headline" v-else>経緯表変更</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex md3 xs6>
                                        <v-menu :close-on-content-click="false" transition="scale-transition" offset-y
                                            max-width="290px" min-width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="historyData.target_date" label="実施日"
                                                    persistent-hint v-bind="attrs"
                                                    @blur="date = parseDate(historyData.target_date)" v-on="on"
                                                    :rules="rules.target_date" width="120px" :disabled="disableDate()">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker v-model="date" :day-format="date => new Date(date).getDate()"
                                                no-title></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex md3 xs6>
                                        <v-dialog ref="dialog" v-model="timePick"
                                            :return-value.sync="historyData.target_time" persistent width="290px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="historyData.target_time" label="実施時刻" readonly
                                                    v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-time-picker v-if="timePick" v-model="historyData.target_time" full-width
                                                scrollable :allowed-minutes="allowedStep" format="24hr" min="10:00"
                                                max="21:00">
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="timePick = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary"
                                                    @click="$refs.dialog.save(historyData.target_time)">
                                                    OK
                                                </v-btn>
                                            </v-time-picker>
                                        </v-dialog>
                                    </v-flex>
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.counselor_id" :items="counselors" label="実施CO"
                                            item-text="name" item-value="id" :rules="rules.counselor_id"
                                            required></v-select>
                                    </v-flex>
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.kind" :items="CUSTOMER.EXEC_KIND.LIST"
                                            label="取組区分" :rules="rules.kind" required
                                            :disabled="disableKind()"></v-select>
                                    </v-flex>
                                </v-layout>

                                <!-- 入会 -->
                                <v-layout wrap v-if="isContract(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-checkbox v-model="historyData.option.verTel" label="AD差し戻し済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6>
                                        <v-checkbox v-model="historyData.option.decCO" label="担当CO決定済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6>
                                        <v-checkbox v-model="historyData.option.letter" label="お礼の手紙送付済"></v-checkbox>
                                    </v-flex>
                                </v-layout>

                                <!-- カウンセリング -->
                                <v-layout wrap v-if="isCounseling(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="counselingAndSimulationList"
                                            label="状態"></v-select>
                                    </v-flex>
                                </v-layout>

                                <!-- 第一回CO -->
                                <v-layout wrap v-if="isCO1(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="execList" label="状態"></v-select>
                                    </v-flex>
                                    <!-- 予定 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 2">
                                        <v-checkbox v-model="historyData.option.verTel" label="日時確認済"></v-checkbox>
                                    </v-flex>
                                </v-layout>

                                <!-- 第二回CO & お相手選び -->
                                <v-layout wrap v-if="isSelect(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="execList" label="状態"></v-select>
                                    </v-flex>
                                    <!-- 予定 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 2">
                                        <v-checkbox v-model="historyData.option.verTel" label="日時確認済"></v-checkbox>
                                    </v-flex>
                                    <!-- 実施 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-select v-model="historyData.option.result" :items="selectResult"
                                            label="結果"></v-select>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-checkbox v-model="historyData.option.resTel" label="結果報告TEL済"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap
                                    v-if="isSelect(historyData.kind) && historyData.status == 3 && customer.gender != 2">
                                    <v-data-table :headers="targetHeaders" class="elevation-1"
                                        :items="historyData.option.targets"
                                        :server-items-length="historyData.option.targets.length" hide-default-footer
                                        dense
                                        v-if="historyData.option.targets && historyData.option.targets.length > 0">
                                        <template v-slot:[`item.result`]="{ item }">
                                            <v-switch v-model="item.result" dense inset color="info darken-2"
                                                :label="item.result ? 'OK' : 'NG'"></v-switch>
                                        </template>
                                    </v-data-table>
                                </v-layout>
                                <v-layout wrap
                                    v-if="isSelect(historyData.kind) && historyData.status == 2 && customer.gender != 2">
                                    <v-flex md3 xs6
                                        v-if="!historyData.option.targets || historyData.option.targets.length == 0">
                                        <v-btn class="info" @click="openMatching(true)">お相手選択
                                        </v-btn>
                                    </v-flex>
                                    <v-data-table :headers="targetReserveHeaders" class="elevation-1"
                                        :items="historyData.option.targets"
                                        :server-items-length="historyData.option.targets.length" hide-default-footer
                                        dense v-else>
                                        <template v-slot:[`item.result`]="{ item }">
                                            <v-checkbox v-model="item.result" dense></v-checkbox>
                                        </template>
                                    </v-data-table>
                                </v-layout>

                                <!-- 第三回CO & シミュレーション -->
                                <v-layout wrap v-if="isSimulation(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="counselingAndSimulationList"
                                            label="状態"></v-select>
                                    </v-flex>
                                    <!-- 予定 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 2">
                                        <v-checkbox v-model="historyData.option.verTel" label="日時確認済"></v-checkbox>
                                    </v-flex>
                                </v-layout>

                                <!-- お見合い -->
                                <v-layout wrap v-if="isMatching(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="matchingList"
                                            label="状態"></v-select>
                                    </v-flex>
                                    <!-- 予定 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 2">
                                        <v-checkbox v-model="historyData.option.verTel" label="日時確認済"></v-checkbox>
                                    </v-flex>
                                    <!-- 実施 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-select v-model="historyData.option.result" :items="matchingResult"
                                            label="結果"></v-select>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-checkbox v-model="historyData.option.follTel" label="フォローTEL済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3 && historyData.option.result">
                                        <v-checkbox v-model="historyData.option.resTel" label="結果報告TEL済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3 && historyData.option.result">
                                        <v-checkbox v-model="historyData.option.isPay" label="入金確認済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6
                                        v-if="historyData.status == 3 && historyData.option.result && historyData.option.isPay">
                                        <v-text-field v-model.number="historyData.option.payVal" type="number"
                                            label="入金額"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap v-if="isMatchingOwn(historyData.kind) && historyData.status == 3">
                                    <v-data-table :headers="targetHeaders" class="elevation-1"
                                        :items="historyData.option.targets"
                                        :server-items-length="historyData.option.targets.length" hide-default-footer
                                        dense
                                        v-if="historyData.option.targets && historyData.option.targets.length > 0">
                                        <template v-slot:[`item.result`]="{ item }">
                                            <v-switch v-model="item.result" dense inset color="info darken-2"
                                                :label="item.result ? 'OK' : 'NG'"></v-switch>
                                        </template>
                                    </v-data-table>
                                </v-layout>
                                <v-layout wrap v-if="isMatchingOwn(historyData.kind) && historyData.status == 2">
                                    <v-flex md3 xs6
                                        v-if="(!historyData.option.targets || historyData.option.targets.length == 0) && customer.gender != 2">
                                        <v-btn class="info" @click="openMatching(false)">お相手選択
                                        </v-btn>
                                    </v-flex>
                                    <v-data-table :headers="targetReserveHeaders" class="elevation-1"
                                        :items="historyData.option.targets"
                                        :server-items-length="historyData.option.targets.length" hide-default-footer
                                        dense v-else-if="historyData.option.targets">
                                        <template v-slot:[`item.result`]="{ item }">
                                            <v-checkbox v-model="item.result" dense></v-checkbox>
                                        </template>
                                    </v-data-table>
                                </v-layout>

                                <!-- デート -->
                                <v-layout wrap v-if="isDate(historyData.kind)">
                                    <v-flex md3 xs6>
                                        <v-select v-model="historyData.status" :items="execList" label="状態"></v-select>
                                    </v-flex>
                                    <!-- 予定 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 2">
                                        <v-checkbox v-model="historyData.option.verTel" label="日時確認済"></v-checkbox>
                                    </v-flex>
                                    <!-- 実施 -->
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-checkbox v-model="historyData.option.follTel" label="フォローTEL済"></v-checkbox>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3">
                                        <v-select v-model="historyData.option.result" :items="matchingResult"
                                            label="結果"></v-select>
                                    </v-flex>
                                    <v-flex md3 xs6 v-if="historyData.status == 3 && historyData.option.result">
                                        <v-checkbox v-model="historyData.option.resTel" label="結果報告TEL済"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-textarea v-model="historyData.note" label="フォロー内容" no-resize rows="4">
                                        </v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="info" @click="addHistory" v-if="!isUpdate">登録
                            </v-btn>
                            <v-btn class="info" @click="updateHistory" v-else>保存
                            </v-btn>
                            <v-btn @click="closeDialog">キャンセル</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <CompanyVisit :date="date" :dialogCV="dialogCV" :historyData="historyData" :boothNos="boothNos"
                :shop_id="this.customer.shop_id" :counselors="counselorsForForm" @closeDialogCV="dialogCV = false"
                @refreshListHistory="loadInit" :hideTitle="true" :valueKindForForm="valueKindForForm"
                :customer="this.customer" @switchForm="handleSwitchForm" />
            <!-- InHouseMatchmaking -->
            <InHouseMatchmaking :date="date" :boothNos="boothNos" :counselors="counselorsForFormInHouse"
                :shop_id="this.customer.shop_id" @refreshListHistory="loadInit"
                :showFormInHouseMatching="showFormInHouseMatching"
                @closeFormInHouseMatching="showFormInHouseMatching = false" :historyData="historyData"
                :hideTitleForm="true" :valueKindForForm="valueKindForForm" :customer="this.customer"
                :boothNos2="boothNos2" @switchForm="handleSwitchForm" />
            <!-- ConnectMatchmaking -->
            <ConnectMatchmaking :date="date" :boothNos="boothNos" :counselors="counselorsForForm"
                :shop_id="this.customer.shop_id" @refreshListHistory="loadInit"
                :showFormConnectMatching="showFormConnectMatching"
                @closeFormConnectMatching="showFormConnectMatching = false" :historyData="historyData"
                :hideTitleForm="true" :valueKindForForm="valueKindForForm" :customer="this.customer" />
            <!-- DateMatchmaking -->
            <DateMatchmaking :date="date" :boothNos="boothNos" :counselors="counselorsForForm"
                :shop_id="this.customer.shop_id" @refreshListHistory="loadInit"
                :showFormDateMatching="showFormDateMatching" @closeFormDateMatching="showFormDateMatching = false"
                :historyData="historyData" :hideTitleForm="true" :valueKindForForm="valueKindForForm"
                :customer="this.customer" />
            <PartnerSelection :date="date" :boothNos="boothNos" :counselors="counselorsForForm"
                :shop_id="this.customer.shop_id" @refreshListHistory="loadInit"
                :showFormMatchingHistory="showFormMatchingHistory"
                @closeFormMatchingHistory="showFormMatchingHistory = false" :historyData="historyData"
                :hideTitleForm="true" :valueKindForForm="valueKindForForm" :customer="this.customer"
                :oldHistory="oldHistory" />
            <OtherHistoryTable :date="date" :boothNos="boothNos" :counselors="counselorMasters"
                @refreshListHistory="loadInit" :showFormOtherHistory="showFormOtherHistory"
                @closeFormOtherHistory="showFormOtherHistory = false" :historyData="historyData" :hideTitle="true"
                :valueKindForForm="valueKindForForm" :shop_id="this.shopId || this.customer.shop_id"
                :customer="this.customer" />
        </v-layout>
        <v-layout row justify-center>
            <v-dialog v-model="deleteDialog" persistent max-width="290px">
                <v-card>
                    <v-card-title> 削除しますか？ </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark class="delete" @click="deleteHistory">削除</v-btn>
                        <v-btn @click="deleteClose">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row justify-center>
            <v-dialog v-model="selectMatchingDialog" persistent max-width="1200px">
                <v-card>
                    <v-card-title>お相手選択</v-card-title>
                    <selectMatching ref="childSM" :isMultiple="isMultiple" :onCancel="onCancel" :onSubmit="onSubmit">
                    </selectMatching>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import { VueEditor } from "vue2-editor";
import ACCOUNT from "@/consts/account.js";
import CUSTOMER from "@/consts/customer.js";
import utilDatetime from "@/utilities/datetime.js"
import selectMatching from "@/components/Matching.vue";
import CompanyVisit from "@/components/CompanyVisit";
import InHouseMatchmaking from "@/components/InHouseMatchmaking";
import ConnectMatchmaking from "@/components/ConnectMatchmaking";
import DateMatchmaking from "@/components/DateMatchmaking";
import PartnerSelection from "@/components/PartnerSelection";
import OtherHistoryTable from "@/components/OtherHistoryTable";
import constants from '@/consts/constants.js'
import store from '@/store'
import moment from "moment";

export default {
    components: {
        selectMatching,
        CompanyVisit,
        InHouseMatchmaking,
        ConnectMatchmaking,
        DateMatchmaking,
        PartnerSelection,
        OtherHistoryTable,
        VueEditor
    },
    async beforeRouteLeave(to, from, next) {
        const isDistinctive = this.customerNote !== this.customer.note;
        if (isDistinctive) {
            await this.onEditorBlur();
            next();
        } else {
            next()
        }
    },
    title() {
        return `${this.customer.family_name} ${this.customer.given_name} (経緯表)`;
    },
    name: 'customer_hisotory',
    mixins: [utilDatetime],
    data: () => ({
        kinds: CUSTOMER.KINDS.LIST,
        counselorsForForm: [],
        counselorMasters: [],
        counselorsForFormInHouse: [],
        boothNos: [],
        boothNos2: [],
        dialogCV: false,
        showFormInHouseMatching: false,
        showFormConnectMatching: false,
        showFormDateMatching: false,
        showFormMatchingHistory: false,
        showFormOtherHistory: false,
        valueKindForForm: '',
        formItems: [
            { title: 'TELする', form: 'その他経緯表入力', value: 1 },
            { title: 'TEL受ける', form: 'その他経緯表入力', value: 2 },
            { title: 'TELする（留守電）', form: 'その他経緯表入力', value: 1017 },
            { title: 'メールする', form: 'その他経緯表入力', value: 1008 },
            { title: 'メール受ける', form: 'その他経緯表入力', value: 1009 },
            { title: 'OKTEL', form: 'その他経緯表入力', value: 3 },
            { title: '断TEL', form: 'その他経緯表入力', value: 4 },
            { title: 'その他', form: 'その他経緯表入力', value: 51 },
            { title: 'お見合い', form: '自社見合', value: 24 },
            { title: '連盟見合', form: '連盟見合', value: 26 },
            { title: '他支店見合', form: '自社見合', value: 1006 },
            { title: 'デート①', form: 'デート', value: 31 },
            { title: 'デート②', form: 'デート', value: 32 },
            { title: 'デート③', form: 'デート', value: 33 },
            { title: '他支店デート', form: 'デート', value: 1005 },
            { title: 'お相手選び', form: 'お相手選び入力', value: 111 },
            { title: 'お申込み紹介', form: 'お相手選び入力', value: 1018 },
            { title: 'カウンセリング', form: '来社入力', value: 14 },
            { title: '当シフトCO', form: '来社入力', value: 1016 },
            { title: '先シフトCO', form: '来社入力', value: 1002 },
            { title: 'オリ①', form: '来社入力', value: 121 },
            { title: '第２回CO', form: 'お相手選び入力', value: 122 },
            { title: '第３回CO', form: '来社入力', value: 123 },
            { title: '見合ｼﾐｭﾚｰｼｮﾝ', form: '来社入力', value: 1003 },
            { title: 'ﾃﾞｰﾄｼﾐｭﾚｰｼｮﾝ', form: '来社入力', value: 1004 },
            { title: '交際開始', form: 'その他経緯表入力', value: 1010 },
            { title: '交際破断', form: 'その他経緯表入力', value: 1011 },
            // { title: '訪問', form: 'その他経緯表入力', value: 13 },
            { title: '成婚', form: 'その他経緯表入力', value: 1012 },
            { title: '入会', form: 'その他経緯表入力', value: 101 },
            { title: 'シフト入会', form: 'その他経緯表入力', value: 102 },
            { title: '女性入会', form: 'その他経緯表入力', value: 9999 },
            { title: 'AD面談', form: '来社入力', value: 501 },
            { title: 'CO営業', form: '来社入力', value: 131 },
            { title: '女性初回', form: '来社入力', value: 201 },
            { title: 'ミニお茶コン', form: 'その他経緯表入力', value: 1013 },
            { title: 'イベント', form: 'その他経緯表入力', value: 1014 },
            { title: 'セミナー', form: 'その他経緯表入力', value: 1015 },
            { title: 'ズームCO', form: '来社入力', value: 12 },
            { title: '使用不可', form: '来社入力', value: 1001 },
        ],
        CUSTOMER: CUSTOMER,
        customer: {
            shop_id: null,
            counselor_id: null,
            number: "",
            valid_mail: false,
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
            gender: 1,
            blood_type: 1,
            birthday: "",
            phone_number: "",
            phone_number_home: "",
            email_address: "",
            zip: "",
            pref: 0,
            address1: "",
            address2: "",
            building_name: "",
            line_link: "",
            connect_federation: false,
            ibj_federation: false,
        },
        counselors: [],
        loading: true,
        dialog: false,
        histories: [],
        headers: [
            { text: "日時", value: "target_date", align: "start", sortable: false },
            { text: "取組区分", value: "kind", align: "start", sortable: false },
            { text: "実施CO", value: "counselor_id", align: "start", sortable: false },
            { text: "状態", value: "status", align: "start", sortable: false },
            { text: "フォロー内容", value: "note", align: "start", sortable: false },
            { text: "", value: "buttons", align: "right", sortable: false },
        ],
        targetReserveHeaders: [
            { text: "名前", value: "name", align: "start", sortable: false },
        ],
        targetHeaders: [
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "結果", value: "result", align: "start", sortable: false },
        ],
        date: null,
        timePick: false,
        isUpdate: false,
        historyData: {
            id: null,
            phone: null,
            target_date: null,
            target_time: null,
            kind: 0,
            counselor_id: null,
            note: "",
            status: 0,
            option: {
                verTel: false,
                isPay: false,
                payVal: 0,
                follTel: false,
                result: 0,
                resTel: false,
                decCO: false,
                letter: false,
                matchRes: 0,
                matchTel: false,
                targets: [],
            }
        },
        historyTemplate: {
            target_date: null,
            target_time: null,
            kind: 0,
            counselor_id: null,
            note: "",
            status: 0,
            option: {
                verTel: false,
                isPay: false,
                payVal: 0,
                follTel: false,
                result: 0,
                resTel: false,
                decCO: false,
                letter: false,
                matchRes: 0,
                matchTel: false,
                targets: [],
            }
        },
        selectedHistoryId: 0,
        rules: {
            target_date: [
                (v) => !!v || "日時を入力してください",
            ],
            kind: [
                (v) => !!v || "取組区分を選択してください",
            ],
            counselor_id: [
                (v) => !!v || "実施COを選択してください",
            ],
        },
        selectResult: [
            { value: 1, text: "見合候補決めた。女性に連絡する。" },
            { value: 2, text: "全員選ばず。再度お相手選び入れる。" },
        ],
        counselingAndSimulationList: [
            { value: 1, text: "仮予定" },
            { value: 2, text: "予定" },
            { value: 3, text: "実施" },
            { value: 5, text: "不実施" },
        ],
        matchingList: [
            { value: 1, text: "仮予定" },
            { value: 2, text: "予定" },
            { value: 3, text: "実施" },
            { value: 4, text: "不履行" },
        ],
        matchingResult: [
            { value: 1, text: "〇" },
            { value: 2, text: "×" },
        ],
        execList: [
            { value: 1, text: "仮予定" },
            { value: 2, text: "予定" },
            { value: 3, text: "実施" },
        ],
        deleteTargetId: 0,
        deleteDialog: false,
        selectMatchingDialog: false,
        isMultiple: false,
        shopId: null,
        counselor: {},
        counselor2: {},
        oldHistory: {
            id: '',
            target_date: '',
            target_time: '',
            target_time_end: '',
        },
        notExecutedStatuses: [
            CUSTOMER.NOT_EXECUTED_STATUS.getValue('不履行'),
            CUSTOMER.NOT_EXECUTED_STATUS.getValue('不実施')
        ],
        customerNote: '',
        customToolbar: [
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ color: [] }, { background: [] }],
            ['link'],
        ],
        hasCloseDialog: false,
        moment: moment,
        claimFiles: [],
        course: {},
        endDate: null,
        endDateShift: null
    }),
    watch: {
        date() {
            this.historyData.target_date = this.formatDate(this.date);
        },
        shopId() {
            this.filterBoothNo();
        },
        showFormInHouseMatching() {
            this.hasCloseDialog = true;
        }
    },
    created() {
        this.getListBoothNo();
        this.getClaimFiles()
        window.addEventListener('scroll', this.handleScroll);
    },
    async mounted() {
        this.getCO();
        this.historyData = Object.assign({}, this.historyTemplate);
        await this.loadInit();
        const historyId = this.$route.query.id || -1;
        const fromScreen = this.$route.query.fromScreen || null
        if (historyId < 0 || fromScreen === 'ledger') return;
        if (historyId == 0) {
            this.addDialog();
        } else {
            this.updateDialog(historyId);
        }
        this.filterBoothNo();
    },
    methods: {
        openLineLink() {
            if (this.customer.line_link) {
                window.open(this.customer.line_link, '_blank');
            }
        },
        async getClaimFiles() {
            const id = this.$route.params.id;
            const claimFiles = await this.$axios.get(`/api/v1/customer/${id}/claim-files`);
            this.claimFiles = claimFiles.data;
        },
        handleScroll() {
            if (this.showFormInHouseMatching || this.hasCloseDialog) {
                this.hasCloseDialog = false;
                window.scrollTo(0, 0);
            }
        },
        async onEditorBlur() {
            const $toastr = this.$toastr;
            await this.$axios
                .put(`/api/v1/customer/${this.customer.id}/note`, { note: this.customerNote })
                .then(() => {
                    $toastr.s('メモを保存しました');
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        showCounselorName(history) {
            const counselorId = (this.customer.gender === CUSTOMER.GENDER.VAL.FEMALE && history.counselor2_id !== null) ? history.counselor2_id : history.counselor_id
            const counselor = this.counselors.find(counselor => counselor.id == counselorId);
            if (!counselor) return '';
            return counselor.name;
        },
        async loadInit() {
            const id = this.$route.params.id;
            const result = await this.$axios
                .get(`/api/v1/customer/${id}/history`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });

            if (result) {
                this.customer = result.customer;
                this.customerNote = this.customer.note;
                this.histories = result.histories;
                this.counselors = result.counselors;
                this.shopId = result.customer.shop_id;
                this.course = result.course;
                this.getEndDate()
                this.getEndDateShift()
                this.setTitle();
            }
            this.loading = false;
        },
        async addHistory() {
            await this.$axios
                .post(`/api/v1/customer/${this.customer.id}/history`, { historyData: this.historyData })
                .then((response) => {
                    this.histories.unshift(response.data.history);
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            this.sortHistory();
            this.closeDialog();
            this.$refs.childSM.loadInit();
        },
        async updateHistory() {
            const id = this.selectedHistoryId;
            await this.$axios
                .put(`/api/v1/customer/${this.customer.id}/history`, { historyId: id, historyData: this.historyData })
                .then(() => {
                    const history = this.histories.find(history => history.id == id);
                    history.target_date = this.historyData.target_date;
                    history.target_time = this.historyData.target_time;
                    history.kind = this.historyData.kind;
                    history.counselor_id = this.historyData.counselor_id;
                    history.note = this.historyData.note;
                    history.status = this.historyData.status;
                    history.option = this.historyData.option
                    history.id = id;
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            this.sortHistory();
            this.closeDialog();
            this.$refs.childSM.loadInit();
        },
        sortHistory() {
            this.histories.sort((a, b) => (b.target_date > a.target_date) ? 1 : -1);
        },
        addDialog() {
            this.isUpdate = false;
            this.historyData = Object.assign({}, this.historyTemplate);
            this.dialog = true;
        },
        updateDialog(id) {
            this.valueKindForForm = ''
            this.isUpdate = true;
            this.selectedHistoryId = id;
            const history = this.histories.find(history => history.id == id);
            if (!history) return;
            this.counselor = history.counselor
            if (history.counselor2_id !== null) {
                this.counselor = this.counselorMasters.find(counselor => counselor.id === history.counselor_id)
                this.counselor2 = this.counselorMasters.find(counselor => counselor.id === history.counselor2_id)
            }
            this.filterBoothNo()
            if (store.state.user.shop_id === 0 || (this.customer && this.customer.id === 999999999)) {
                this.counselorsForForm = this.counselorMasters
            } else {
                this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === this.customer.shop_id)
            }
            this.historyData = {
                id: id,
                phone: this.customer.phone_number.trim(),
                given_name: this.customer.given_name,
                family_name: this.customer.family_name,
                gender: this.customer.gender,
                customer_id: history.customer_id,
                booth_no_id: history.booth_no_id,
                booth_no2_id: history.booth_no2_id,
                target_date: history.target_date,
                target_time: history.target_time,
                target_time_end: history.target_time_end,
                kind: history.kind,
                counselor_id: history.counselor_id,
                counselor2_id: history.counselor2_id,
                status: history.status,
                type: history.type,
                note: history.note,
                female_customer: history.female_customer,
                male_customer: history.male_customer,
                connect_flag: history.connect_flag,
                connect_no: history.connect_no,
                connect_name: history.connect_name,
                connect_area: history.connect_area,
                matching_histories: history.matching_histories,
                shift_negotiations: history.shift_negotiations,
                is_online: history.is_online,
                option: Object.assign({}, history.option)
            };

            /** ブースNoがある場合には、該当ブースNoのショップIDを付与する */
            /** 消すな！！！！！！！！！！！！！！！！！！！！！！！！！！！*/
            if (this.historyData.booth_no_id != null) {
                this.getBoothNo(this.historyData.booth_no_id)
            }
            if (!this.shopId) {
                this.shopId = this.counselor.shop_id
            }

            switch (this.historyData.type) {
                case constants.TYPE_FORM.COMPANY_VISIT_INPUT:
                    this.dialogCV = true;
                    break;
                case constants.TYPE_FORM.IN_HOUSE_MATCH:
                    this.showFormInHouseMatching = true
                    break;
                case constants.TYPE_FORM.CONNECT_ARRANGEMENT:
                    this.showFormConnectMatching = true
                    break;
                case constants.TYPE_FORM.DATE_INPUT:
                    this.showFormDateMatching = true
                    break;

                case constants.TYPE_FORM.INPUT_PARTNER_SELECTION:
                    this.showFormMatchingHistory = true
                    break;

                case constants.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT:
                    this.showFormOtherHistory = true
                    break;
                default:
                    this.dialog = true;
            }

        },
        closeDialog() {
            this.dialog = false;
        },
        formatDate(date) {
            if (!date) return null

            try {
                const [year, month, day] = date.split('-')
                return `${year}/${month}/${day}`
            } catch {
                return null;
            }
        },
        parseDate(date) {
            if (!date) return null

            try {
                const [year, month, day] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            } catch {
                return null;
            }
        },
        allowedStep: m => m % 10 === 0,
        disableDate() {
            if (this.historyData && this.isSelect(this.historyData.kind) && (this.historyData.status == 2 || this.historyData.status == 3)) return true;
            if (this.historyData && this.isMatching(this.historyData.kind) && (this.historyData.status == 2 || this.historyData.status == 3)) return true;
            return false;
        },
        disableKind() {
            if (this.historyData && this.isSelect(this.historyData.kind) && (this.historyData.status == 2 || this.historyData.status == 3)) return true;
            if (this.historyData && this.isMatching(this.historyData.kind) && (this.historyData.status == 2 || this.historyData.status == 3)) return true;
            return false;
        },
        statusToStr(status) {
            switch (status) {
                case 1: return "仮";
                case 2: return "予定";
                case 3: return "実施";
                case 4: return "不履行";
                case 5: return "不実施";
                default: return "実施";
            }
        },
        drawStatus(history) {
            if (this.isContract(history.kind)) {
                return "実施　"
                    + (history.option.verTel ? "AD差し戻し済　" : "")
                    + (history.option.decCO ? "担当CO決定済　" : "")
                    + (history.option.letter ? "手紙送付済み" : "");
            } else if (this.isCounseling(history.kind)) {
                return this.statusToStr(history.status);
            } else if (this.isCO1(history.kind)) {
                return this.statusToStr(history.status)
                    + (history.status == 2 && history.option.verTel ? "　日時確認済" : "");
            } else if (this.isMatching(history.kind)) {
                return this.statusToStr(history.status)
                    + (history.status == 2 && history.option.verTel ? "　日時確認済み" : "")
                    + (history.status == 3 ?
                        (history.option.follTel ? "　フォローTEL済" : "")
                        + (history.option.resTel ? "　結果報告TEL済" : "")
                        + (history.option.result ? "　結果入力済" : "")
                        + (history.option.isPay ? "　入金確認済み" : "")
                        : "");
            } else if (this.isSelect(history.kind)) {
                return this.statusToStr(history.status)
                    + (history.status == 2 && history.option.verTel ? "　日時確認済み" : "")
                    + (history.status == 3 ?
                        (history.option.result ? "　結果入力済" : "")
                        + (history.option.resTel ? "　結果報告TEL済" : "")
                        : "");
            } else if (this.isSimulation(history.kind)) {
                return this.statusToStr(history.status)
                    + (history.status == 2 && history.option.verTel ? "　日時確認済み" : "");
            } else if (this.isDate(history.kind)) {
                return this.statusToStr(history.status)
                    + (history.status == 2 && history.option.verTel ? "　日時確認済み" : "")
                    + (history.status == 3 ?
                        (history.option.follTel ? "　フォローTEL済" : "")
                        + (history.option.result ? "　結果入力済" : "")
                        + (history.option.resTel ? "　結果報告TEL済" : "")
                        : "");
            } else if (history.type == CUSTOMER.TYPE_FORM.OTHER_HISTORY_TABLE_INPUT) {
                // その他経緯表入力のtypeの場合は、常に"実施"を返却する
                return "実施";
            } else {
                return this.statusToStr(history.status);
                //return CUSTOMER.STATUS.getText(history.status);
            }
        },
        // 取組区分の表示名を返す（連盟見合はconnect_flagに基づきIBJ見合/コネクト見合と表示）
        getKindName(item) {
            let name;
            if (item.kind === this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING && item.connect_flag) {
                name = item.connect_flag === this.CUSTOMER.CONNECT_FLAG.VAL.CONNECT
                    ? this.CUSTOMER.CONNECT_FLAG.NAME.CONNECT
                    : this.CUSTOMER.CONNECT_FLAG.NAME.IBJ;
            } else {
                name = CUSTOMER.EXEC_KIND.getName(item.kind);
            }
            return item.is_online == 1 ? name + '(On)' : name;
        },
        // 区分から表示する状態を選択する
        isContract(kind) {
            return kind == CUSTOMER.EXEC_KIND.VAL.CONTRACT;
        },
        isCounseling(kind) {
            return kind == CUSTOMER.EXEC_KIND.VAL.COUNSELING;
        },
        isCO1(kind) {
            return kind == CUSTOMER.EXEC_KIND.VAL.COUNSELING_1;
        },
        isMatching(kind) {
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.MATCHING_1) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.MATCHING_2) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.MATCHING_3) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.MATCHING) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING) return true;
            return false;
        },
        isMatchingOwn(kind) {
            if (!this.isMatching(kind)) return false;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING) return false;
            return true;
        },
        isSelect(kind) {
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.COUNSELING_2) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.SELECT_MATCH) return true;
            return false;
        },
        isSimulation(kind) {
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.COUNSELING_3) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.SIMULATION) return true;
            return false;
        },
        isDate(kind) {
            if (kind == CUSTOMER.EXEC_KIND.VAL.DATE) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.DATE2) return true;
            if (kind == this.CUSTOMER.EXEC_KIND.VAL.DATE3) return true;
        },
        // 削除
        canDelete() {
            const self = this.$store.state.user;

            if (self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if (self.privilege & ACCOUNT.PRIVILEGE.VAL.HISTORY_DELETE) return true;
            return false;
        },
        deleteConfirm(id) {
            this.deleteTargetId = id;
            this.deleteDialog = true;
        },
        deleteClose() {
            this.deleteTargetId = 0;
            this.deleteDialog = false;
        },
        deleteHistory() {
            this.$axios
                .delete(`/api/v1/customer/${this.customer.id}/history`, { params: { historyId: this.deleteTargetId } })
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.loadInit();
                    this.deleteClose();
                });
        },
        canStop() {
            const self = this.$store.state.user;

            if (self.privilege & ACCOUNT.PRIVILEGE.VAL.SYSTEM_ADMIN) return true;
            if (self.privilege & ACCOUNT.PRIVILEGE.VAL.ALERT_STOP) return true;
            return false;
        },
        stopAlert() {
            this.$axios
                .post(`/api/v1/customer/${this.customer.id}/alert/stop`)
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.customer.is_stop_alert = true;
                    //this.loadInit();
                });
        },
        restartAlert() {
            this.$axios
                .post(`/api/v1/customer/${this.customer.id}/alert/restart`)
                .catch((error) => {
                    console.log("Error : " + error);
                })
                .then(() => {
                    this.customer.is_stop_alert = false;
                    //this.loadInit();
                });
        },
        openSheet(sheet_id) {
            if (!sheet_id) return;
            window.open(`https://docs.google.com/spreadsheets/d/${sheet_id}`, '_blank')
        },
        openMatching(isMultiple) {
            this.isMultiple = isMultiple;
            this.selectMatchingDialog = true;
        },
        onCancel() {
            this.selectMatchingDialog = false;
        },
        async onSubmit(selected) {
            this.historyData.option.targets = selected.map(s => ({
                id: s.id,
                name: s.name,
                result: false,
            }));
            this.selectMatchingDialog = false;
        },
        async getListBoothNo() {
            await this.$axios
                .get("/api/v1/booth_no")
                .then((response) => {
                    this.boothNoMasters = response.data.booth_nos
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },

        async getBoothNo(boothNoId = null) {
            if (boothNoId) {
                await this.$axios
                    .get(`/api/v1/booth_no/${boothNoId}`)
                    .then((response) => {
                        this.shopId = response.data.booth_no.shop_id
                    })
                    .catch((error) => {
                        console.log("Error : " + error);
                    });
            }
        },
        filterBoothNo() {
            if (this.counselor !== undefined) {
                this.boothNos = this.boothNoMasters.filter(item => {
                    return item.shop_id == this.counselor.shop_id
                })
            } else {
                this.boothNos = []
            }

            if (this.counselor2 !== undefined) {
                this.boothNos2 = this.boothNoMasters.filter(item => {
                    return item.shop_id == this.counselor2.shop_id;
                })
            } else {
                this.boothNos2 = []
            }
        },
        getCO() {
            const shopIdToGetAllCounselor = 0
            let shopIdForFormInHouse = store.state.user.shop_id
            if (shopIdForFormInHouse === 0) {
                shopIdForFormInHouse = 1
            }

            this.$axios
                .get(`/api/v1/user/counselors?shop_id=${shopIdToGetAllCounselor}`)
                .then((response) => {
                    this.counselorMasters = response.data.counselors
                    if (store.state.user.shop_id === 0) {
                        this.counselorsForForm = this.counselorMasters
                    } else {
                        this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === store.state.user.shop_id)
                    }
                    this.counselorsForFormInHouse = this.counselorMasters.filter(counselor => counselor.shop_id === shopIdForFormInHouse)
                })
                .catch((error) => {
                    console.log("Error : " + error)
                })
        },
        callFormCreate(formItem) {
            if (store.state.user.shop_id === 0 || (this.customer && this.customer.id === 999999999)) {
                this.counselorsForForm = this.counselorMasters
            } else {
                this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === this.customer.shop_id)
            }
            switch (formItem.form) {
                case CUSTOMER.TYPE_FORM_NAME.COMPANY_VISIT_INPUT:
                    this.valueKindForForm = formItem.value
                    this.dialogCV = true;
                    break;
                case CUSTOMER.TYPE_FORM_NAME.IN_HOUSE_MATCH:
                    this.valueKindForForm = formItem.value
                    this.showFormInHouseMatching = true
                    break;
                case CUSTOMER.TYPE_FORM_NAME.CONNECT_ARRANGEMENT:
                    this.valueKindForForm = formItem.value
                    this.showFormConnectMatching = true
                    break;
                case CUSTOMER.TYPE_FORM_NAME.DATE_INPUT:
                    this.valueKindForForm = formItem.value
                    this.showFormDateMatching = true
                    break;
                case CUSTOMER.TYPE_FORM_NAME.INPUT_PARTNER_SELECTION:
                    this.valueKindForForm = formItem.value
                    this.showFormMatchingHistory = true
                    break;
                case CUSTOMER.TYPE_FORM_NAME.OTHER_HISTORY_TABLE_INPUT:
                    this.valueKindForForm = formItem.value
                    this.showFormOtherHistory = true
                    break;
                default:
                    this.dialog = true;
            }
        },
        clickBtnCreateForm() {
            if (constants.NOT_MEMBER_CUSTOMER == this.customer.shop_id) {
                if (this.historyData.booth_no_id != null) {
                    this.getBoothNo(this.historyData.booth_no_id)
                } else {
                    this.shopId = this.historyData.option.shop_id
                }
            } else {
                this.shopId = this.customer.shop_id;
            }
        },
        handleSwitchForm(formType, kind) {
            if (kind) {
                this.valueKindForForm = kind
                this.closeAllForms()
                this.showFormMatchingHistory = true
            } else {
                this.callFormCreateForSwitchType(formType)
            }
        },
        closeAllForms() {
            this.dialogCV = false
            this.showFormInHouseMatching = false
            this.showFormMatchingHistory = false
            this.showFormConnectMatching = false
            this.showFormDateMatching = false
            this.showFormOtherHistory = false
        },
        callFormCreateForSwitchType(formType) {
            if (store.state.user.shop_id === 0 || (this.customer && this.customer.id === 999999999)) {
                this.counselorsForForm = this.counselorMasters
            } else {
                this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === this.customer.shop_id)
            }
            this.oldHistory = {
                id: this.historyData.id,
                target_date: this.historyData.target_date,
                target_time: this.historyData.target_time,
                target_time_end: this.historyData.target_time_end,
            }
            this.closeAllForms()
            switch (formType) {
                case CUSTOMER.TYPE_FORM.INPUT_PARTNER_SELECTION:
                    this.showFormMatchingHistory = true
                    break;
                default:
                    break;
            }
        },
        rowClass(item) {
            return this.notExecutedStatuses.includes(item.status) ? 'not-executed-row' : ''
        },
        computedTextAlign(header) {
            return 'text-' + this.headers.find(h => h.value === header).align
        },
        getEndDate() {
            const course = this.course
            this.endDate = course && course.end_date ?
                moment(course.end_date).locale('ja').format('YYYY年M月D日') :
                moment(course.contract_date).locale('ja').add(1, 'y').format('YYYY年M月D日')
        },
        getEndDateShift() {
            const course = this.course;
            const endDate = course && course.end_date ? moment(course.end_date) : moment(course.contract_date).add(1, 'y');
            const dateRangeStart = moment(endDate).subtract(3, 'M');
            const dateRangeEnd = moment(endDate).add(1, 'M');
            
            if (!moment().isBetween(dateRangeStart, dateRangeEnd)) {
                this.endDateShift = null;
                return;
            }

            const shiftKinds = [CUSTOMER.EXEC_KIND.VAL.AHEAD_SHIFT_CO, CUSTOMER.EXEC_KIND.VAL.THIS_SHIFT_CO];
            const relevantShifts = this.histories.filter(h =>
                shiftKinds.includes(h.kind) &&
                moment(h.target_date).isBetween(dateRangeStart, dateRangeEnd)
            );

            const completedShifts = relevantShifts.filter(h => h.status === 3)
                .sort((a, b) => moment(`${a.target_date} ${a.target_time}`).diff(`${b.target_date} ${b.target_time}`));

            if (completedShifts.length === 0) {
                const hasScheduledShifts = relevantShifts.some(h => h.status !== 3);
                this.endDateShift = hasScheduledShifts ? "未実施 / 次回シフト予定日:有り" : "未実施";
                return;
            }

            const lastShift = completedShifts[completedShifts.length - 1];
            let shiftText = moment(lastShift.target_date).locale('ja').format('YYYY年M月D日');
            
            if (lastShift.shift_negotiations !== null) {
                shiftText += `/${CUSTOMER.STATUS_SHIFT_NEGOTIATIONS.getName(lastShift.shift_negotiations)}`;
            }

            const hasNextShift = relevantShifts.some(h =>
                h.status !== 3 && moment(h.target_date).isAfter(moment(lastShift.target_date))
            );
            
            shiftText += `/次回シフト予定日:${hasNextShift ? '有り' : '無し'}`;
            this.endDateShift = shiftText;
        }
    }
}
</script>

<style>
.table-history th:nth-child(1) {
    width: 10% !important;
}

.table-history th:nth-child(2) {
    width: 15% !important;
}

.table-history th:nth-child(3) {
    width: 10% !important;
}

.table-history th:nth-child(4) {
    width: 15% !important;
}

.not-executed-row {
    background-color: #f0908d;
}

.not-executed-row:hover {
    background-color: #f0908d !important;
    opacity: 0.9;
}

#customer-note .ql-editor {
    min-height: 100px !important;
    overflow-y: scroll;
    height: 100px;
    font-size: 14px;
}

.quillWrapper {
    margin: 0 10px 10px 10px;
    max-width: 277vh;
}

#note-message {
    margin-left: 10px;
    font-size: 13px;
}

.toast-top-right {
    top: 80px !important;
    font-size: 14px;
}

.toast-container>div {
    width: 195px !important;
}

#note {
    padding: 0 16px 16px 16px;
}

.history__name {
    font-size: 1.25rem;
    font-weight: bold;
}

.history-note {
    max-width: 1024px;
    word-wrap: break-word;
}
</style>
